import { ViewDensity, ViewType } from "@common/types/views/views";
import { AccountsView } from "@common/types/views/accountsView";
import { ViewConfig } from "@lib/views";
import { AccountsTableColumn, AccountsTableRow } from "./accountsView.types";
import { EntityOrAccountCell } from "./cells/EntityOrAccountCell";
import { TeamCell } from "./cells/TeamCell";
import { AccountTypeCell } from "./cells/AccountTypeCell";
import { StatusCell } from "./cells/StatusCell";
import { BalanceCell } from "./cells/BalanceCell";
import { ActionsCell } from "./cells/ActionsCell";

export const accountsViewConfig: ViewConfig<
    AccountsTableRow,
    AccountsTableColumn,
    never
> = {
    columns: {
        [AccountsTableColumn.ENTITY_OR_ACCOUNT]: {
            accessorKey: "id",
            name: "Account",
            header: "Account",
            immutable: true,
            minSize: 360,
            maxSize: 1200,
            cell: EntityOrAccountCell,
        },
        [AccountsTableColumn.TEAM]: {
            accessorKey: "assignedMembers",
            name: "Members",
            header: "Members",
            minSize: 200,
            maxSize: 200,
            cell: TeamCell,
        },
        [AccountsTableColumn.ACCOUNT_TYPE]: {
            accessorKey: "account",
            name: "Type",
            header: "Type",
            minSize: 176,
            maxSize: 176,
            cell: AccountTypeCell,
        },
        [AccountsTableColumn.STATUS]: {
            accessorKey: "account",
            name: "Status",
            header: "Status",
            minSize: 180,
            maxSize: 220,
            cell: StatusCell,
        },
        [AccountsTableColumn.BALANCE]: {
            accessorKey: "id",
            name: "Net balance",
            header: "Net balance",
            minSize: 140,
            maxSize: 140,
            cell: BalanceCell,
        },
        [AccountsTableColumn.ACTIONS]: {
            accessorKey: "id",
            name: "Actions",
            header: "",
            minSize: 60,
            maxSize: 240,
            immutable: true,
            hiddenFromSettings: true,
            cell: ActionsCell,
        },
    },
    nesting: {
        enabled: true,
        expandColumn: AccountsTableColumn.ENTITY_OR_ACCOUNT,
        childrenKey: "accounts",
    },
};

export const accountsView: AccountsView = {
    type: ViewType.ACCOUNTS,
    filters: {},
    columns: [
        {
            id: AccountsTableColumn.ENTITY_OR_ACCOUNT,
        },
        { id: AccountsTableColumn.TEAM },
        { id: AccountsTableColumn.ACCOUNT_TYPE },
        { id: AccountsTableColumn.STATUS },
        { id: AccountsTableColumn.BALANCE },
        { id: AccountsTableColumn.ACTIONS, options: { pin: "right" } },
    ],
    options: {
        density: ViewDensity.MD,
    },
};
